import { render, staticRenderFns } from "./SurveyNavigate.vue?vue&type=template&id=0c0488fe&"
import script from "./SurveyNavigate.vue?vue&type=script&lang=ts&"
export * from "./SurveyNavigate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports